<template>
	<div style="background-color: #000000;">
		<h2 style="text-align: center;color: white;background-color: #0F0B26;padding: 20px;margin-bottom: 20px;">公寓服务数据统计</h2>
		<div style="display: flex;margin-bottom: 20px;">
			<kfxq style="width: 32%;" :kfxq="kfxq" :isTrue='isTrue'></kfxq>
			<jrqk style="margin:0 20px;width: 36%;"  :isTrue='isTrue'></jrqk>
			<rcxx style="width: 32%;" :rcxx="rcxx" :isTrue='isTrue'></rcxx>
		</div>
		<div style="display: flex;margin-bottom: 20px;">
			
			<rcrzqs  style="width: 32%;" :rcqs="rcqs" :isTrue='isTrue'></rcrzqs>
			<fwtj style="margin:0 20px;width: 36%;" :fwtj="fwtj" :isTrue='isTrue'></fwtj>
			<fwpj style="width: 32%;" :isTrue='isTrue'></fwpj>
			<!-- <kfxq :kfxq="kfxq" :isTrue='isTrue'></kfxq> -->
		</div>
		<!-- <div style="display: flex;">
			<fwtj style="margin-right: 20px;" :fwtj="fwtj" :isTrue='isTrue'></fwtj>
			<fwpj :fwpj="fwpj" :isTrue='isTrue'></fwpj>
		</div> -->
	</div>
</template>

<script>
	import rcrzqs from "./component/rcrzqs.vue"
	import jrqk from "./component/jrqk.vue"
	import rcxx from "./component/rcxx.vue"
	import kfxq from "./component/kfxq.vue"
	import fwtj from "./component/fwtj.vue"
	import fwpj from "./component/fwpj.vue"
	export default {
		components: {
			rcrzqs,jrqk,rcxx,kfxq,fwtj,fwpj
		},
		data() {
			return {
				rcqs:"123",
				jrqk:'222',
				rcxx:'333',
				kfxq:'444',
				fwtj:'555',
				fwpj:'666',
				isTrue:false
			}
		},
		mounted() {
			this.getInfo()
			
		},
		methods: {
			getInfo(){//获取前六个echarts图数据
				this.$http.get("/api/screen/getTalentStatistical").then(res=>{
					if(res.data.code==0){		
						var rcqs=[]
						rcqs.push(res.data.data.人才入住情况)
						rcqs.push(res.data.data.访客申请情况)
						rcqs.push(res.data.data.退房申请情况)
						var jrqk=[]
						jrqk.push(res.data.data.今日人才入住数量)
						jrqk.push(res.data.data.今日访客申请数量)
						jrqk.push(res.data.data.今日退房申请数量)
						var fwtj=[]
						fwtj.push(res.data.data.服务申请)
						fwtj.push(res.data.data.报修申请)
						fwtj.push(res.data.data.投诉建议)
						var fwpj=[]
						fwpj.push(res.data.data.好评数)
						fwpj.push(res.data.data.差评数)
						fwpj.push(res.data.data.未处理数)
						this.rcqs=rcqs
						this.jrqk=jrqk
						this.fwtj=fwtj
						this.fwpj=fwpj
						this.isTrue=true
					}
					console.log(res)
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped="scoped">


</style>
